<template>
  <div>
    <transition-group name='fade' tag='div'>
      <div v-for="number in [currentNumber]" :key='number'>
        <a :href="currentUrl" class="block"><img :src="currentImage" v-on:mouseover="stopRotation" v-on:mouseout="startRotation"/></a>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  data() {
    return {
      images: [
        {
          src: '/img/banner-photos-1.png',
          url: '/services'
        },
        {
          src: '/img/banner-photos-2.png',
          url: '/services'
        },
        {
          src: '/img/banner-photos-3.png',
          url: '/services'
        },
        {
          src: '/img/banner-photos-4.png',
          url: '/services'
        },                             
      ],      
      currentNumber: 0,
      timer: null
    }
  },
  mounted: function() {
    this.startRotation();
  },
  methods: {
    startRotation: function() {
      this.timer = setInterval(this.next, 6000);
    },
    stopRotation: function() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    next: function() {
      this.currentNumber += 1
    },
    prev: function() {
      this.currentNumber -= 1
    }
  },
  computed: {
    currentImage: function() {
      return this.images[Math.abs(this.currentNumber) % this.images.length].src;
    },
    currentUrl: function() {
      return this.images[Math.abs(this.currentNumber) % this.images.length].url;
    }    
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: all 0.8s ease;
  overflow: hidden;
  visibility: visible;
  opacity: 1;
  position: absolute;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  visibility: hidden;
}
</style>